module.exports = __webpack_public_path__ + "media/images/flags/1x1/arm-2061ab330093b4c4f1cb0b4b92911640.svg";